export const INPUT_ID = 'inlineEditInput'

export const TEST_IDS = {
  EDIT_ICON: 'editIcon',
  CLOSE_ICON: 'closeIcon',
  AUTOCOMPLETE: 'autocomplete',
}
